// Dependencias generales
import React from "react";
import { useEffect , useState} from 'react';
import GoogleMapComponent from "../Utils/GoogleMapComponent.js";
import Loader from '../../components/Utils/Loader';

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postFindNearestWeatherStations = endpointHelias+'/Helias/V0/Configuration/postFindNearestWeatherStations'

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var scrollList
var scrollListStyles
var scrollListContentStyles
var scrollListWidth
var scrollListContentWidth

// Función del router
const InitialConfigAsideMapMenu = (params) => {

  useEffect(() => {           
    
    scrollList = document.getElementById("divScroll"); 
    
    if( Object.keys(params.jsonConfigData).length > 0 ){
      console.log("Seteo la ubicacion actual en el mapa")
      setSelectedLocation([{ id: "UBICACION_ACTUAL", distance: 0, lat: parseFloat(params.jsonConfigData.GeneralInfo.InstallationLocationLatitude), long: parseFloat(params.jsonConfigData.GeneralInfo.InstallationLocationLongitude) }])
    }
    
    cargarEstacionesMeteorologicasCercanas()         

    window.addEventListener('resize', scrollListOnScroll)    
  },[]);

  const [availableWeatherStations, setAvailableWeatherStations] = useState([])
  const [selectedLocation, setSelectedLocation] = useState([{ id: "", distance: "", lat: "", long: "" }])
  const [selectedWeatherStation, setSelectedWeatherStation] = useState([{ id: "", distance: "", lat: "", long: "" }])

  var locationLatitude = 0.0
  
  function setlocationLatitude(valor){
    locationLatitude = valor
  }

  var locationLongitude = 0.0
  
  function setlocationLongitude(valor){
    locationLongitude = valor
  }
  
  function prevArrowOnClick(){
    scrollList.scroll({
      left: scrollList.scrollLeft -scrollListWidth,
      behavior: "smooth"
    });
  }

  function nextArrowOnClick(){
    scrollList.scroll({
      left: scrollList.scrollLeft + scrollListWidth,
      behavior: "smooth"
    });
  }

  function scrollListOnScroll(){
    updateSizes();
    updateArrows(document.getElementById("divScroll").scrollLeft);
  }

  function updateSizes(){    
    scrollListStyles = window.getComputedStyle(document.getElementById("divScroll"));
    scrollListContentStyles = window.getComputedStyle(document.getElementById("listadoEstaciones"));
    scrollListWidth = document.getElementById("divScroll").clientWidth - parseFloat(scrollListStyles.paddingLeft) - parseFloat(scrollListStyles.paddingRight);
    scrollListContentWidth = document.getElementById("listadoEstaciones").clientWidth - parseFloat(scrollListContentStyles.paddingLeft) - parseFloat(scrollListContentStyles.paddingRight) - 52
  }

  function updateArrows(scrollLeft){

    if ( scrollLeft === 0 ) {
      document.getElementById("flechaAtras").setAttribute('disabled','disabled');
    } else {
      document.getElementById("flechaAtras").removeAttribute('disabled');
    }
    
    if ( scrollLeft < (scrollListContentWidth - scrollListWidth ) ) {
      document.getElementById("flechaAdelante").removeAttribute('disabled');
    } else {
      document.getElementById("flechaAdelante").setAttribute('disabled','disabled');
    }
  }

  document.addEventListener("mousedown", (event) => {        
    if(event.target.id  === "menuLateralMeteo"){
      initialConfigCommonJS.operarMenuMapaLateral("cerrar")
    }
  }); 

  function cargarEstacionesMeteorologicasCercanas(latitud,longitud){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  

    document.getElementById("loaderWeatherStationsInfo").className="loader overlay"    
    document.getElementById("seccionSelectorEstacion").style="display: none"    
    document.getElementById("seccionMapa").style="display: none"    

    //Registro las credenciales para el MONITOR del usuario        
    var xhttp = new XMLHttpRequest();
    xhttp.open("POST", postFindNearestWeatherStations, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);

    var data = ""

    if( (latitud !== undefined) && (longitud !== undefined) ){
      data = JSON.stringify({"accountID": localStorage.getItem("accountID"), "installationID": ongoingInstallationConfigurationID, "latitude": latitud.toString(), "longitude": longitud.toString()});
    }
    else{
      data = JSON.stringify({"accountID": localStorage.getItem("accountID"), "installationID": ongoingInstallationConfigurationID});
    }

    xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {                
            console.log("Estaciones meteorológicas cargadas correctamente.")            

            try{
              document.getElementById("loaderWeatherStationsInfo").className="loader hidden"    
            }
            catch(error){console.log(error)}
            
            if(document.getElementById("loaderWeatherStationsInfo") !== null){
  
              document.getElementById("seccionSelectorEstacion").style="display"    
              document.getElementById("seccionMapa").style="display"    
            
              var jsonRespuestaEstacionesMeteorologicas = JSON.parse(this.responseText)
              
              try {                
                if(jsonRespuestaEstacionesMeteorologicas.body.weatherStationsList.length > 0){
                  setAvailableWeatherStations(jsonRespuestaEstacionesMeteorologicas.body.weatherStationsList)
                  
                  var estacionActualConfigurada = document.getElementById("estacionSeleccionada").value
                  var estacionMasCercana = ""
                  var estacionesAuxiliares = ""

                  if(estacionActualConfigurada === ""){
                    estacionMasCercana = jsonRespuestaEstacionesMeteorologicas.body.weatherStationsList[0]              
                  }
                  else{//Selecciono la guardada
                    for (var i = 0; i < jsonRespuestaEstacionesMeteorologicas.body.weatherStationsList.length; i++) {
                      if(estacionActualConfigurada === jsonRespuestaEstacionesMeteorologicas.body.weatherStationsList[i].Id){                  
                        estacionMasCercana = jsonRespuestaEstacionesMeteorologicas.body.weatherStationsList[i]              
                      }
                      
                      if( i !== jsonRespuestaEstacionesMeteorologicas.body.weatherStationsList.length-1){
                        estacionesAuxiliares = estacionesAuxiliares + jsonRespuestaEstacionesMeteorologicas.body.weatherStationsList[i].Id + "|"
                      }
                      else{
                        estacionesAuxiliares = estacionesAuxiliares + jsonRespuestaEstacionesMeteorologicas.body.weatherStationsList[i].Id
                      }

                    }

                    document.getElementById("estacionesAuxiliares").value = estacionesAuxiliares

                  }

                  //Realizo nueva comprobación por si la estación anterior guardada ya no existe
                  if(estacionMasCercana === ""){
                    estacionMasCercana = jsonRespuestaEstacionesMeteorologicas.body.weatherStationsList[0]              
                  }

                  //Si aun así no hay más estaciones muestro mensaje informativo
                  if(estacionMasCercana !== ""){

                    setSelectedWeatherStation([{ id: estacionMasCercana.Id, distance: estacionMasCercana.Distance,lat: estacionMasCercana.Latitude, long: estacionMasCercana.Longitude }])                          
                    updateArrows(scrollList.scrollLeft);
                    updateSizes();
                    document.getElementById("flechaAdelante").classList.remove('hidden');
                    window.onresize = updateSizes();

                    document.getElementById("avatarMeteoStFigure").className = "avatar size-m cyan"
                    document.getElementById("avatarMeteoStSpan").innerHTML = "person_pin_circle"
                    document.getElementById("estacionSeleccionadaSpan").innerHTML = estacionMasCercana.Id
                    document.getElementById("estacionSeleccionadaP").innerHTML = "A "+estacionMasCercana.Distance+" Km"
                    document.getElementById("estacionSeleccionada").value = estacionMasCercana.Id             

                  }
                }                            
                else{                
                  initialConfigCommonJS.mostrarMensajeInformativo('No hay estaciones públicas disponibles cerca de esa ubicación. Prueba a buscar de nuevo en los alrededores.','negative')              
                }
              }
              catch (error) {  
                initialConfigCommonJS.mostrarMensajeInformativo('El servicio global de estaciones meteorológicas (WUNDERGROUND) no está operativo, inténtelo de nuevo pasados unos minutos.','negative')                          
              }
            }            
        }            
        if (this.readyState === 4 && this.status !== 200) {                            
            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }            
    };
    xhttp.send(data);  
      
  }

  function seleccionarEstacion(){     
    document.getElementById("divSelectorEstacionMeteorologica").className = "selection icon-wrapper"          
    document.getElementById("divErrorValidacionFormulario").className = document.getElementById("divErrorValidacionFormulario").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById(selectedWeatherStation[0].id).checked=true
    document.getElementById("estacionSeleccionadaSpan").innerHTML = selectedWeatherStation[0].id
    document.getElementById("estacionSeleccionadaP").innerHTML = "A "+selectedWeatherStation[0].distance+" Km"
    document.getElementById("estacionSeleccionada").value = selectedWeatherStation[0].id        
    document.getElementById("fieldsetEstacionMeteorologicaActual").className = document.getElementById("fieldsetEstacionMeteorologicaActual").className.replaceAll(" hidden", "")

    initialConfigCommonJS.operarMenuMapaLateral("cerrar")
  }

  const WeatherStationsList = (params) => {    

    useEffect(() => {                 
      if(selectedWeatherStation[0].id !== ""){
        document.getElementById(selectedWeatherStation[0].id).checked=true        
      }         
      updateSizes();
      updateArrows(document.getElementById("divScroll").scrollLeft);
    },[]);

    if(params.availableWeatherStations.length > 0){
      const listWeatherStations = params.availableWeatherStations.map((weatherStation) =>
        <React.Fragment key={weatherStation.Id}>
        <input type="radio" id={weatherStation.Id} value={weatherStation.Id} name="weather-station"/>
        <label className="vertical icon-wrapper" htmlFor={weatherStation.Id} onClick={() => setSelectedWeatherStation([{ id: weatherStation.Id, distance: weatherStation.Distance, lat: weatherStation.Latitude, long: weatherStation.Longitude }])}>
            <figure className="avatar size-m"></figure>
            <div className="content">
            <h1 className="label">{weatherStation.Id}</h1> 
            <p className="size-s uppercase">{weatherStation.Location}</p>
            <p className="size-s uppercase">A {weatherStation.Distance} Km</p>
            </div>
        </label>
        </React.Fragment>
      );    

      return (
        <>{listWeatherStations}</>
      )
    }
    else{      
      return (
        <p>No hay estaciones meteorológicas disponibles.</p>
      );
    }
  }

  return (
    <aside id="menuLateralMeteo" className="modal hidden">
        <div className="modal-content">
        <button className="link close" onClick={() => initialConfigCommonJS.operarMenuMapaLateral("cerrar")}><span className="material-icon">cancel</span></button>
        <header>
            <figure className="avatar size-m orange"><span className="material-icon">brightness_medium</span></figure>
            <h1 className="headline-03">Estaciones meteorológicas</h1>
        </header> 
        
        <section id="seccionSelectorEstacion" className="weather-devices fill gap-04">
          
          <div className="scroll-wrapper">
            <button id="flechaAtras" className="button arrow previous" onClick={() => prevArrowOnClick()}><span className="material-icon">arrow_back</span></button>
            <div id="divScroll" className="inner-scroll" onScroll={() => scrollListOnScroll()}>
              <fieldset id="listadoEstaciones" className="radio multiple">                
                  <WeatherStationsList availableWeatherStations={availableWeatherStations}/>
              </fieldset>
            </div>
            <button id="flechaAdelante" className="button arrow next" onClick={() => nextArrowOnClick()}><span className="material-icon">arrow_forward</span></button>
          </div>

          <button className="button primary full-width" onClick={() => seleccionarEstacion()}>Seleccionar</button>          

          <section id="seccionMapa" className="weather-map">            
            <GoogleMapComponent mapId={"mapaEstaciones"} coordenadas={selectedWeatherStation} setlocationLatitude={setlocationLatitude} setlocationLongitude={setlocationLongitude} defaultView="Map"/>
          </section>

        </section>        

        <Loader Id="loaderWeatherStationsInfo" Mensaje=""/>

        </div>
    </aside>
  )
}

export default InitialConfigAsideMapMenu